import { Button, Space, Tabs } from "antd";
import PageHeader from "components/PageHeader";
import { useProjectQuestions, useProjectPackages } from "features/ProjectType/data/hooks";
import { mapProjectType } from "features/ProjectType/data/mappers";
import DetailMetaRow from "features/ProjectType/presentation/components/DetailMetaRow";
import DetailMetaField from "features/ProjectType/presentation/components/DetailMetaField";
import ProjectTypeFormModal from "features/ProjectType/presentation/components/ProjectTypeFormModal";
import { ProjectTypeState, VisibilityBadge } from "features/ProjectType/presentation/components/ProjectTypeState";
import QuestionTab from "./components/QuestionTab";
import PackageTab from "./components/PackageTab";
import useProjectTypeDetail from "./useProjectTypeDetail";
import "./index.scss";
export default function ProjectTypeDetail() {
  const vm = useProjectTypeDetail();
  const questions = useProjectQuestions(vm.id);
  const packages = useProjectPackages(vm.id);
  const record = vm.data ? mapProjectType(vm.data) : {};
  const error = [vm.error, questions.error, packages.error].find((value) => value?.code === "FORBIDDEN") || vm.error;
  return (
    <div className="project-type-page">
      <PageHeader
        pageTitle="Chi tiết loại dự án"
        routes={[
          { name: "Cài đặt hệ thống", path: "/setting" },
          { name: "Cấu hình loại dự án", path: "/setting/project-type" },
          { name: record.name },
        ]}
      />
      <ProjectTypeState loading={vm.loading} data={vm.data} error={error} refetch={vm.refetch}>
        <div className="project-type-card project-type-toolbar">
          <Space>
            <strong>{record.name}</strong>
            <VisibilityBadge visible={record.isVisible} />
          </Space>
          <Space>
            <Button onClick={() => vm.setEditing(true)}>Chỉnh sửa</Button>
            <Button disabled={vm.saving} onClick={vm.changeVisibility}>
              {record.isVisible ? "Ẩn khỏi app" : "Hiện trên app"}
            </Button>
          </Space>
        </div>
        <div className="project-type-card">
          <Tabs>
            <Tabs.TabPane tab="Thông tin chung" key="general">
              {[
                ["Tên loại dự án", record.name],
                ["Hiển thị trên app tại", record.displayPlace === "CARD" ? "Thẻ riêng trên form" : "Trong mục Khác"],
                ["Thứ tự hiển thị", record.displayOrder],
                ["Trạng thái", <VisibilityBadge visible={record.isVisible} />],
                ["Mô tả ngắn", record.shortDescription || "—"],
                ["Số gói đề xuất", `${record.visiblePackageTierCount}/4 mức`],
                ["Cập nhật lần cuối", record.updatedAtLabel],
                ["Người cập nhật", record.updatedByLabel],
              ].map(([label, value]) => (
                <DetailMetaRow key={label}>
                  <DetailMetaField label={label}>{value}</DetailMetaField>
                </DetailMetaRow>
              ))}
            </Tabs.TabPane>
          </Tabs>
        </div>
        <div className="project-type-card">
          <Tabs defaultActiveKey="packages">
            <Tabs.TabPane tab={`Gói đề xuất (${packages.data?.length || 0})`} key="packages">
              <PackageTab query={packages} projectTypeId={vm.id} onTypeRefresh={vm.refetch} />
            </Tabs.TabPane>
            <Tabs.TabPane tab={`Bộ câu hỏi (${questions.data?.length || 0})`} key="questions">
              <QuestionTab query={questions} projectTypeId={vm.id} projectTypeName={record.name} />
            </Tabs.TabPane>
          </Tabs>
        </div>
        {vm.editing && (
          <ProjectTypeFormModal current={vm.data} onSaved={vm.onSaved} onClose={() => vm.setEditing(false)} />
        )}
      </ProjectTypeState>
    </div>
  );
}
